module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/ElEQVQ4jZ3Tv0oEMRDH8c/uHaKd4AtYCP7Fyl4QBHtREFQsr7OxEF/AzhewFO3s7EVbK/EEC0utToOdggoWm5X1yCJ7A4FfJjPfyTBJFkJQY4s4i3oD16mgrAbQwgMm4v4RU/juD8xrqq9VkkW9ngpMAVrYT/gPMNTvbMe1gnlMYgEzCcAc7nCjaK+LiyyEcILNdCf/2mkWQnjH8ICAjxxXAybDZY4tRT9N7RbbOXpYwn2D5C6W8VKOsYdOA0An5vx5B+0GgJFSVAGp2dfZdAow2wDwW6x67a++oDccRb2LscrZZymqv3Ec54qPc4xDvMazUexhB89YxRP8AHf4Mv02arK7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/无星.png
// module id = GAMD
// module chunks = 1